// extracted by mini-css-extract-plugin
export default {"chat-member-access":"ChatMemberAccess_chat-member-access__BFV+e"};